export enum FormResponseCreateSubmissionError {
  formVersionNotFound = 'formVersionNotFound',
  invalidSubmissionValue = 'invalidSubmissionValue',
}
